import { render, staticRenderFns } from "./Import1.vue?vue&type=template&id=745aa060&scoped=true&"
import script from "./Import1.vue?vue&type=script&lang=js&"
export * from "./Import1.vue?vue&type=script&lang=js&"
import style0 from "./Import1.vue?vue&type=style&index=0&id=745aa060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745aa060",
  null
  
)

export default component.exports